<template>
  <div>
    <vm-table
        ref="vmTable"
        height="64vh"
        :filter.sync="filter"
        module="basic"
        url="sd/so/getEIDList">
      <template slot="adSearch">
        <div class="vm-search">
          <vm-search label="合同号">
            <el-input
                v-model.trim="filter.clientContractNo"
                type="textarea"
                autosize
                clearable/>
          </vm-search>
          <vm-search label="序列号">
            <el-input v-model.trim="filter.serialNo" clearable/>
          </vm-search>
          <vm-search label="EID">
            <el-input v-model.trim="filter.eid" clearable/>
          </vm-search>
          <vm-search label="IV号">
            <el-input v-model.trim="filter.mainSerialNo" clearable/>
          </vm-search>
        </div>
      </template>
      <el-table-column prop="clientContractNo" width="250px" align="center" label="合同号"/>
      <el-table-column prop="serialNo" align="center" label="序列号"/>
      <el-table-column prop="eid" align="center" label="EID"/>
      <el-table-column prop="mainSerialNo" align="center" label="IV号"/>
    </vm-table>
  </div>
</template>

<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch";
  export default {
    name: "EIDList",
    components: {VmTable,VmSearch},
    data() {
      return {
        filter:{
          serialNo:"",
          eid:"",
          clientContractNo:"",
          mainSerialNo:"",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
    },
  };
</script>

<style scoped>

</style>
